import { useContext } from 'react';
import { OpenPanelContext } from '../OpenPanelProvider';

export const useOpenPanel = () => {
  const openPanelContext = useContext(OpenPanelContext);

  if (!openPanelContext) {
    throw new Error('useOpenPanel must be used within an OpenPanelProvider');
  }

  const { openPanel } = openPanelContext;
  return openPanel;
};
